import { Component, OnInit } from '@angular/core';

import { first } from "rxjs/operators";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LigneFinancementMarcheService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement-marche.service';
import { LigneFinancementMarche } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancementMarche';

@Component({
  selector: "app-edit-ligne-financement-marche",
  templateUrl: "./edit-ligne-financement-marche.component.html",
  styleUrls: ["./edit-ligne-financement-marche.component.scss"]
})
export class EditLigneFinancementMarcheComponent implements OnInit {
  ligneFinancement: LigneFinancementMarche;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ligneFinancementService: LigneFinancementMarcheService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {}

  createForm(ligneFinancement: LigneFinancementMarche) {
    this.form2 = this.fb.group({
      code: [ligneFinancement.code, Validators.compose([Validators.required])],
      libelle: [
        ligneFinancement.libelle,
        Validators.compose([Validators.required])
      ],
      montant: [
        ligneFinancement.montant,
        Validators.compose([Validators.required])
      ],
      codeLigneFinancement: [
        ligneFinancement.ligneFinancementId,
        Validators.compose([Validators.required])
      ]
    });
  }

  ngOnInit() {
    this.createForm(this.ligneFinancement);
  }

  save(): void {
    this.pressButton = true;
    const id = this.ligneFinancement.id;
    this.ligneFinancement = this.form2.value;
    this.ligneFinancement.id = id;

    this._ligneFinancementService
      .update(this.ligneFinancement)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close(this.ligneFinancement);
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
